export default __webpack_public_path__ + "static/media/bg_hyper.9ce09eec.svg";